import { css } from '@portal/styled-system/css'
import type { ColorToken } from '@portal/styled-system/tokens'

import { useI18n } from '@/shared/lib/i18n'
import { Button, ButtonPlainBack, Modal, type ModalProps, ProceedButton } from '@/shared/ui'

type AccountNotProtectedDialogProps = ModalProps & {
    email: string
    onLaterButtonClick: () => void
    onChangeAddressButtonClick: () => void
    onVerifyAddressButtonClick: () => void
    title?: string
    titleIconClass?: string
    intro?: string
    headerBackgroundColor?: ColorToken
}

export function AccountNotProtectedDialog({
    email,
    onLaterButtonClick,
    onChangeAddressButtonClick,
    onVerifyAddressButtonClick,
    title,
    titleIconClass,
    intro,
    headerBackgroundColor = 'danger',
    ...modalProps
}: AccountNotProtectedDialogProps) {
    const { i18n } = useI18n()

    const titleLabel = title ?? i18n.EMAIL_NOT_VERIFIED__TITLE
    const description = intro ?? i18n.EMAIL_NOT_VERIFIED__BODY

    const titleIconClassName = titleIconClass ?? 'fa-solid fa-shield-slash'

    return (
        <Modal {...modalProps}>
            <Modal.Header styles={css.raw({ backgroundColor: headerBackgroundColor })} icon={titleIconClassName}>
                {titleLabel}
            </Modal.Header>
            <Modal.Body>
                <span dangerouslySetInnerHTML={{ __html: description.replace('{email}', email) }} />
            </Modal.Body>
            <Modal.Buttons styles={css.raw({ flexDirection: 'column', gap: '1', paddingBottom: '2' })}>
                <ProceedButton onPress={onVerifyAddressButtonClick}>
                    {i18n.EMAIL_NOT_VERIFIED__BTN_VERIFY}
                </ProceedButton>
                <Button color="info" onPress={onChangeAddressButtonClick} styles={css.raw({ mt: '1' })}>
                    {i18n.EMAIL_NOT_VERIFIED__BTN_CHANGE}
                </Button>
                <ButtonPlainBack onPress={onLaterButtonClick} />
            </Modal.Buttons>
        </Modal>
    )
}
